import { render } from "./ClassEditPage.vue?vue&type=template&id=15525b0a"
import script from "./ClassEditPage.vue?vue&type=script&lang=js"
export * from "./ClassEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__